import React from 'react';
import ParentDashboard from '../components/ParentDashboard';

const ParentDashboardPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <ParentDashboard />
      </div>
    </div>
  );
};

export default ParentDashboardPage;